import { UI_STYLES } from "@/styles/uiStyles";
import LuckyCardItem from "./LuckyCardItem";
import { LuckyCard } from "../types/LuckyCard";

interface LuckyCardPremiumProps {
  cards: Array<LuckyCard | null>;
  luckyCard: LuckyCard | null;
  onSelectCard: (index: number) => void;
  resetDate: string | null;
}

const LuckyCardPremium = ({
  cards,
  luckyCard,
  onSelectCard,
  resetDate,
}: LuckyCardPremiumProps) => {
  return (
    <div className="flex flex-col items-center px-4 h-[calc(100svh-160px)]">
      <div className="flex flex-col items-center mb-4 w-full flex-shrink-0">
        <div
          className={`rounded-lg  text-white/70 
            px-2 sm:px-3 md:px-4
            text-[10px] sm:text-[12px] md:text-[12px]
               py-1  text-center `}
        >
          До следующей карты
          <br /> {resetDate}
        </div>
        <div className={`rounded-lg mb-4 p-[2px] ${UI_STYLES.buttonGradient}`}>
          <div
            className={`flex flex-col items-center ${UI_STYLES.bgDarkBlue2} text-white font-ubuntu font-light 
            text-[10px] sm:text-[12px] md:text-[14px]
            p-2 sm:p-3 md:p-4
            text-center opacity-70 w-full rounded-lg `}
          >
            Каждую неделю находите счастливую карту и задавайте вопрос
            астрологу! У вас есть 3 дня на открытие! Удачи!
          </div>
        </div>
        <LuckyCardItem height="max-h-[15vh]" card={luckyCard} withoutStatus={true} />
      </div>
      <div
        className="grid w-full flex-1"
        style={{
          gridTemplateColumns: "repeat(4, 1fr)",
          gridTemplateRows: "repeat(3, 1fr)",
          gap: "8px",
          aspectRatio: "4/3",
          minHeight: 0,
        }}
      >
        {cards.map((card, index) => (
          <LuckyCardItem key={index}
            card={card}
            onClick={() => onSelectCard(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default LuckyCardPremium;
